import { useEffect } from "react";
import api from "@/lib/api";

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Injects meta tags + JSON-LD structured data (AEO) for the given path.
export function useSeo(path) {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/public/seo", { params: { path } })
      .then(({ data }) => {
        if (cancelled) return;
        document.title = data.title;
        setMeta("name", "description", data.description);
        setMeta("name", "robots", data.robots);
        setMeta("property", "og:title", data.og_title);
        setMeta("property", "og:description", data.og_description);
        setMeta("property", "og:image", data.og_image);
        setMeta("property", "og:type", "website");
        setMeta("property", "og:url", data.canonical);
        setMeta("name", "twitter:card", "summary_large_image");
        setCanonical(data.canonical);

        document
          .querySelectorAll('script[data-seo-jsonld="true"]')
          .forEach((n) => n.remove());
        (data.jsonld || []).forEach((obj) => {
          const s = document.createElement("script");
          s.type = "application/ld+json";
          s.setAttribute("data-seo-jsonld", "true");
          s.text = JSON.stringify(obj);
          document.head.appendChild(s);
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [path]);
}
